const formatTime = (currentTime: number) => {
    const minutes = Math.floor(currentTime / 60);
    const seconds = Math.floor(currentTime - minutes * 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export default formatTime;
